import { Button, IconButton, InputBase, MenuItem, Select, styled, Typography } from "@mui/material";
import { RoundedBlackBoundary, RowJustifyStartFlex } from "./Containers";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { useEffect, useState } from "react";

const SortDropDownComponent = styled(RoundedBlackBoundary)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-start',
}));

const SortDropDownSelectComponent = styled(Select)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        boxShadow: "none",
    },
    "& .MuiSelect-select": {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: "unset",
    },
    "& .MuiInputBase-root": {
        paddingTop: 0,
        paddingBottom: 0,
    },
    fontSize:'0.7rem',
}));

export default function Sort({ options, defaultOption, sortFieldHandler, directionHandler }) {

    const [field, setField] = useState(defaultOption);
    const [direction, setDirection] = useState('ASC');

    useEffect(() => {
        sortFieldHandler(field);
        directionHandler(direction);
    }, []);

    return (
        <RowJustifyStartFlex gap={1}>
            <Typography variant="body1" noWrap>
                Sort by
            </Typography>
            <SortDropDownComponent>
                <SortDropDownSelectComponent value={field} onChange={(e) => {
                    setField(e.target.value);
                    sortFieldHandler(e.target.value);
                }} size="small" variant="outlined" >
                    {options && options.map(e => <MenuItem key={e.value} value={e.value}>{e.name}</MenuItem>)}
                </SortDropDownSelectComponent>
                <IconButton onClick={() => {
                    if (direction === 'ASC') {
                        setDirection('DESC');
                        directionHandler('DESC');
                    } else {
                        setDirection('ASC');
                        directionHandler('ASC');
                    }
                }} size="small">
                    <FormatListBulletedIcon fontSize="small" />
                    {direction === 'ASC' ? <NorthIcon fontSize="small" /> : <SouthIcon fontSize="small" />}
                </IconButton>
            </SortDropDownComponent>
        </RowJustifyStartFlex>
    );
}